var map = {
	"./anouilh.jpg": "4c5b",
	"./apollinaire.jpg": "699b",
	"./aragon.jpg": "286c",
	"./aristote.jpg": "76e2",
	"./balzac.jpg": "aca1",
	"./baudelaire.jpg": "77be",
	"./beaumarchais.jpg": "d71f",
	"./beckett.jpg": "fb92",
	"./camus.jpg": "3dd4",
	"./celine.jpg": "916a",
	"./chateaubriand.jpg": "5b66",
	"./corneille.jpg": "4d40",
	"./daudet.jpg": "10c7",
	"./de_beauvoir.png": "b29d",
	"./de_musset.jpg": "07e7",
	"./diderot.png": "9a9e",
	"./dostoievski.jpg": "3ea4",
	"./dumas_fils.jpg": "da0b",
	"./dumas_pere.jpg": "ef56",
	"./eluard.jpg": "d65f",
	"./flaubert.jpg": "7edb",
	"./gide.jpg": "5eea",
	"./gogol.jpg": "d03d",
	"./hemingway.jpg": "abe4",
	"./hugo.jpg": "6429",
	"./kessel.jpg": "19bf",
	"./la_bruyere.jpeg": "d44f",
	"./la_fontaine.jpg": "545d",
	"./lamartine.png": "5b92",
	"./malraux.jpeg": "cb72",
	"./maupassant.jpg": "b279",
	"./mirabeau.jpg": "e44c",
	"./moliere.jpg": "4abf",
	"./montesquieu.jpg": "23d0",
	"./pagnol.jpg": "182d",
	"./paul_valery.jpg": "6e07",
	"./perrault.jpg": "dae1",
	"./plume.png": "1ae0",
	"./pouchkine.jpg": "13ff",
	"./prevert.jpg": "90a4",
	"./proust.jpg": "4481",
	"./rabelais.jpg": "e920",
	"./racine.jpg": "1798",
	"./rimbaud.png": "4d09",
	"./romains.jpg": "a8ed",
	"./ronsard.jpg": "48d5",
	"./rostand.jpg": "c467",
	"./rousseau.jpg": "f357",
	"./saint_exupery.jpg": "3eaa",
	"./shakespeare.jpg": "9faa",
	"./stendhal.jpg": "95a9",
	"./tolstoi.jpg": "a6fb",
	"./twain.jpg": "9610",
	"./verlaine.jpg": "1ad2",
	"./verne.jpg": "d9bc",
	"./voltaire.png": "c17e",
	"./yourcenar.jpg": "4bc8",
	"./zola.jpg": "0b6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";